(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m5s-august-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-m5s-product-root]')
    if (!root) return
    const variants = JSON.parse(root.querySelector('[data-m5s-variants]').textContent)
    const optionInputs = [...root.querySelectorAll('[data-option-value]')]
    const idInput = root.querySelector('[data-m5s-variant-id]')
    const price = root.querySelector('[data-m5s-price]')
    const compare = root.querySelector('[data-m5s-compare]')
    const save = root.querySelector('[data-m5s-save]')
    const add = root.querySelector('[data-m5s-atc]')
    const form = root.querySelector('#m5s-product-form')
    const quantity = form?.querySelector('[name="quantity"]')
    const sticky = root.querySelector('[data-m5s-sticky-buy]')
    const stickyPrice = root.querySelector('[data-m5s-sticky-price]')
    const stickyImage = root.querySelector('[data-m5s-sticky-image]')
    const stickyVariant = root.querySelector('[data-m5s-sticky-variant]')
    const stickyQty = root.querySelector('[data-m5s-sticky-qty]')
    const stickyAdd = root.querySelector('[data-m5s-sticky-add]')
    const stickyBuyNow = root.querySelector('[data-m5s-sticky-buy-now]')
    let activeVariant
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100)
    const syncQuantity = () => {
      if (stickyQty && quantity) stickyQty.textContent = String(Math.max(1, Number(quantity.value || 1)))
    }
    const updateVariant = () => {
      const selected = []
      root.querySelectorAll('.m5s-option').forEach(group => {
        const checked = group.querySelector('input:checked')
        selected.push(checked ? checked.value : '')
        const label = group.querySelector('[data-selected-option]')
        if (label && checked) label.textContent = checked.value
      })
      const variant = variants.find(item => item.options.every((value, index) => value === selected[index]))
      if (!variant) return
      activeVariant = variant
      idInput.value = variant.id
      price.textContent = money(variant.price)
      if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''
      if (save) save.textContent = variant.compare_at_price > variant.price ? `Save ${money(variant.compare_at_price - variant.price)}` : ''
      add.disabled = !variant.available
      add.textContent = variant.available ? 'Add to cart' : 'Sold out'
      if (stickyPrice) stickyPrice.textContent = money(variant.price)
      if (stickyVariant) stickyVariant.textContent = variant.title
      if (stickyAdd) stickyAdd.disabled = !variant.available
      if (stickyBuyNow) stickyBuyNow.disabled = !variant.available
      const matchingThumb = root.querySelector(`[data-m5s-color="${variant.options[0].toLowerCase()}"]`)
      if (matchingThumb) matchingThumb.click()
      const affirm = root.querySelector('.affirm-as-low-as')
      if (affirm) {
        affirm.dataset.amount = variant.price
        if (window.affirm && window.affirm.ui) window.affirm.ui.refresh()
      }
    }
    optionInputs.forEach(input => input.addEventListener('change', updateVariant))
    const black = optionInputs.find(input => input.value.toLowerCase() === 'black')
    if (black) black.checked = true
    updateVariant()
    root.querySelectorAll('[data-m5s-image]').forEach(button => button.addEventListener('click', () => {
      const main = root.querySelector('.m5s-main-image')
      if (main) {
        main.removeAttribute('srcset')
        main.removeAttribute('sizes')
        main.src = button.dataset.m5sImage
        if (button.dataset.m5sAlt) main.alt = button.dataset.m5sAlt
        if (stickyImage) {
          stickyImage.src = button.dataset.m5sImage
          stickyImage.alt = main.alt
        }
      }
      root.querySelectorAll('.m5s-thumb').forEach(item => item.classList.remove('is-active'))
      button.classList.add('is-active')
    }))
    optionInputs.forEach(input => input.addEventListener('change', () => {
      const color = input.value.toLowerCase()
      const matchingThumb = root.querySelector(`[data-m5s-color="${color}"]`)
      if (matchingThumb) matchingThumb.click()
    }))
    root.querySelector('[data-m5s-video-play]')?.addEventListener('click', () => {
      const video = root.querySelector('[data-m5s-video]')
      if (!video) return
      video.innerHTML = '<iframe src="https://www.youtube.com/embed/Jeh-RUqbYRY?autoplay=1&rel=0" title="Official Varla M5S riding video" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
    })
    const creatorVideoDialog = root.querySelector('[data-m5s-creator-video-dialog]')
    const creatorVideoPlayer = root.querySelector('[data-m5s-creator-video-player]')
    const creatorVideoTitle = root.querySelector('[data-m5s-creator-video-title]')
    const closeCreatorVideo = () => {
      if (!creatorVideoDialog || !creatorVideoPlayer) return
      creatorVideoPlayer.pause()
      creatorVideoPlayer.removeAttribute('src')
      creatorVideoPlayer.load()
      if (creatorVideoDialog.open) creatorVideoDialog.close()
    }
    root.querySelectorAll('[data-m5s-creator-video]').forEach(button => button.addEventListener('click', () => {
      if (!creatorVideoDialog || !creatorVideoPlayer) return
      creatorVideoTitle.textContent = button.dataset.videoTitle || 'M5S video'
      creatorVideoPlayer.src = button.dataset.videoSrc
      creatorVideoDialog.showModal()
      creatorVideoPlayer.play().catch(() => {})
    }))
    root.querySelector('[data-m5s-creator-video-close]')?.addEventListener('click', closeCreatorVideo)
    creatorVideoDialog?.addEventListener('cancel', event => {
      event.preventDefault()
      closeCreatorVideo()
    })
    creatorVideoDialog?.addEventListener('click', event => {
      if (event.target === creatorVideoDialog) closeCreatorVideo()
    })
    root.querySelector('[data-qty-minus]')?.addEventListener('click', event => {
      const input = event.currentTarget.parentElement.querySelector('input')
      input.value = Math.max(1, Number(input.value || 1) - 1)
      input.dispatchEvent(new Event('change', {bubbles:true}))
    })
    root.querySelector('[data-qty-plus]')?.addEventListener('click', event => {
      const input = event.currentTarget.parentElement.querySelector('input')
      input.value = Number(input.value || 1) + 1
      input.dispatchEvent(new Event('change', {bubbles:true}))
    })
    quantity?.addEventListener('change', syncQuantity)
    quantity?.addEventListener('input', syncQuantity)
    syncQuantity()

    const reviewDialog = root.querySelector('[data-m5s-review-dialog]')
    const reviewList = root.querySelector('[data-m5s-review-list]')
    const reviewLoad = root.querySelector('[data-m5s-review-load]')
    const reviewEmpty = root.querySelector('[data-m5s-review-empty]')
    let reviewRows = []
    let reviewFilter = 'all'
    let reviewLimit = 12
    const escapeReview = value => String(value || '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]))
    const renderReviews = () => {
      if (!reviewList) return
      const ordered = [...reviewRows].sort((a, b) => reviewFilter === 'latest' ? String(b.date).localeCompare(String(a.date)) : 0)
      const filtered = ordered.filter(review => reviewFilter === 'all' || reviewFilter === 'latest' || (reviewFilter === 'media' ? Boolean(review.image) : review.model === reviewFilter))
      reviewList.innerHTML = filtered.slice(0, reviewLimit).map(review => {
        const image = review.image ? `<img src="${escapeReview(review.image)}" alt="Customer photo for ${escapeReview(review.title)}" width="900" height="675" loading="lazy">` : ''
        const status = review.verifiedPurchase ? 'Verified Purchase' : review.sourceType === 'official' ? 'Official-site review · Not marked verified' : 'Archive text · Not labeled verified'
        return `<article>${image}<span class="m5s-review-model">${escapeReview(review.model)}</span><span>${'★'.repeat(Number(review.rating) || 0)}${'☆'.repeat(5 - (Number(review.rating) || 0))}</span><h3>${escapeReview(review.title)}</h3><p>${escapeReview(review.body)}</p><b>${escapeReview(review.reviewer)}</b><small>${escapeReview(review.date)} · ${escapeReview(status)}</small></article>`
      }).join('')
      if (reviewLoad) {
        reviewLoad.hidden = filtered.length <= reviewLimit
        reviewLoad.textContent = `Load ${Math.min(12, Math.max(0, filtered.length - reviewLimit))} more`
      }
      if (reviewEmpty) reviewEmpty.hidden = filtered.length > 0
    }
    const loadReviewArchive = async () => {
      if (!reviewList || reviewRows.length) return
      reviewList.innerHTML = '<p>Loading review archive…</p>'
      try {
        const sources = [['M5S', reviewList.dataset.m5sSource], ['M7S', reviewList.dataset.m7sSource]]
        const [officialResponse, archives] = await Promise.all([
          fetch(reviewList.dataset.officialSource),
          Promise.all(sources.map(async ([model, source]) => {
          const response = await fetch(source, {credentials:'same-origin'})
          if (!response.ok) throw new Error(`${model} review archive ${response.status}`)
          return [model, await response.json()]
          }))
        ])
        if (!officialResponse.ok) throw new Error(`Official review source ${officialResponse.status}`)
        const officialArchive = await officialResponse.json()
        const officialRows = (Array.isArray(officialArchive.reviews) ? officialArchive.reviews : []).map(review => ({
          rating: review.rating,
          title: review.title,
          body: review.body,
          reviewer: review.reviewer_name,
          date: review.created_at,
          model: 'M5S',
          sourceType: 'official',
          verifiedPurchase: Boolean(review.verified_buyer),
          image: review.pictures_urls?.[0]?.original || review.pictures_urls?.[0]?.small || ''
        }))
        const archiveRows = archives.flatMap(([model, archive]) => (Array.isArray(archive.reviews) ? archive.reviews : []).map(review => ({...review, model, sourceType:'archive', verifiedPurchase:false, image:''})))
        reviewRows = [...officialRows, ...archiveRows]
        renderReviews()
      } catch (error) {
        reviewList.innerHTML = '<p>The review archive could not load. Please retry.</p>'
        console.error('[M5S review archive]', error)
      }
    }
    root.querySelector('[data-m5s-reviews-open]')?.addEventListener('click', () => {
      reviewDialog?.showModal()
      loadReviewArchive()
    })
    root.querySelector('[data-m5s-reviews-close]')?.addEventListener('click', () => reviewDialog?.close())
    root.querySelectorAll('[data-m5s-review-filter]').forEach(button => button.addEventListener('click', () => {
      reviewFilter = button.dataset.m5sReviewFilter
      reviewLimit = 12
      root.querySelectorAll('[data-m5s-review-filter]').forEach(item => item.classList.toggle('is-active', item === button))
      renderReviews()
    }))
    reviewLoad?.addEventListener('click', () => { reviewLimit += 12; renderReviews() })
    const mediaLightbox = root.querySelector('[data-m5s-media-lightbox]')
    root.querySelectorAll('[data-m5s-lightbox]').forEach(button => button.addEventListener('click', () => {
      const image = mediaLightbox?.querySelector('img')
      if (image) image.src = button.dataset.m5sLightbox
      mediaLightbox?.showModal()
    }))
    root.querySelector('[data-m5s-lightbox-close]')?.addEventListener('click', () => mediaLightbox?.close())
    root.querySelectorAll('[data-m5s-spec-tab]').forEach(button => button.addEventListener('click', () => {
      const target = button.dataset.m5sSpecTab
      root.querySelectorAll('[data-m5s-spec-tab]').forEach(tab => tab.setAttribute('aria-selected', String(tab === button)))
      root.querySelectorAll('[data-m5s-spec-panel]').forEach(panel => {
        panel.hidden = panel.dataset.m5sSpecPanel !== target
      })
    }))
    const trackingKeys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid']
    root.querySelectorAll('[data-model-link]').forEach(link => {
      const target = new URL(link.href, window.location.origin)
      const current = new URL(window.location.href)
      trackingKeys.forEach(key => {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key))
      })
      link.href = target.href
    })

    const countdown = root.querySelector('[data-m5s-countdown]')
    if (countdown) {
      const end = new Date(countdown.dataset.end).getTime()
      const fields = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      }
      const tick = () => {
        const remaining = Math.max(0, end - Date.now())
        const totalSeconds = Math.floor(remaining / 1000)
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60
        }
        Object.entries(values).forEach(([key, value]) => {
          if (fields[key]) fields[key].textContent = key === 'days' ? String(value) : String(value).padStart(2, '0')
        })
        if (remaining === 0) {
          const label = countdown.querySelector('[data-countdown-label]')
          if (label) label.textContent = 'Offer has ended'
          countdown.hidden = true
        }
      }
      tick()
      window.setInterval(tick, 1000)
    }

    const submitNativeForm = returnToCheckout => {
      if (!form || !activeVariant?.available) return
      let returnTo
      if (returnToCheckout) {
        returnTo = document.createElement('input')
        returnTo.type = 'hidden'
        returnTo.name = 'return_to'
        returnTo.value = '/checkout'
        form.appendChild(returnTo)
      }
      form.requestSubmit()
      if (returnTo) window.setTimeout(() => returnTo.remove(), 100)
    }
    stickyAdd?.addEventListener('click', () => submitNativeForm(false))
    stickyBuyNow?.addEventListener('click', () => submitNativeForm(true))
    if (sticky) {
      const cartRow = root.querySelector('.m5s-cart-row')
      const serviceStrip = root.querySelector('.m5s-service-strip')
      const allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      let stickyWasVisible = false
      let nudgeUsed = false
      let scheduled = false
      const updateSticky = () => {
        scheduled = false
        if (!cartRow) return
        const passedPurchase = cartRow.getBoundingClientRect().bottom < 0
        const reachedFooter = serviceStrip && serviceStrip.getBoundingClientRect().top < window.innerHeight
        const shouldShow = passedPurchase && !reachedFooter
        sticky.classList.toggle('is-visible', shouldShow)
        if (shouldShow && !stickyWasVisible && !nudgeUsed && stickyAdd && allowMotion) {
          nudgeUsed = true
          window.setTimeout(() => stickyAdd.classList.add('is-nudging'), 220)
        }
        stickyWasVisible = shouldShow
      }
      stickyAdd?.addEventListener('animationend', () => stickyAdd.classList.remove('is-nudging'))
      stickyAdd?.addEventListener('pointerdown', () => stickyAdd.classList.remove('is-nudging'), {passive:true})
      window.addEventListener('scroll', () => {
        if (scheduled) return
        scheduled = true
        window.requestAnimationFrame(updateSticky)
      }, {passive:true})
      window.addEventListener('resize', updateSticky)
      updateSticky()
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m7s-august-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-m7s-product-root]')
    if (!root) return
    const variants = JSON.parse(root.querySelector('[data-m7s-variants]').textContent)
    const optionInputs = [...root.querySelectorAll('[data-option-value]')]
    const idInput = root.querySelector('[data-m7s-variant-id]')
    const price = root.querySelector('[data-m7s-price]')
    const compare = root.querySelector('[data-m7s-compare]')
    const save = root.querySelector('[data-m7s-save]')
    const add = root.querySelector('[data-m7s-atc]')
    const form = root.querySelector('#m7s-product-form')
    const quantity = form?.querySelector('[name="quantity"]')
    const sticky = root.querySelector('[data-m7s-sticky-buy]')
    const stickyPrice = root.querySelector('[data-m7s-sticky-price]')
    const stickyImage = root.querySelector('[data-m7s-sticky-image]')
    const stickyVariant = root.querySelector('[data-m7s-sticky-variant]')
    const stickyQty = root.querySelector('[data-m7s-sticky-qty]')
    const stickyAdd = root.querySelector('[data-m7s-sticky-add]')
    const stickyBuyNow = root.querySelector('[data-m7s-sticky-buy-now]')
    let activeVariant
        const m7sProduct = JSON.parse(root.querySelector('[data-m7s-product]').textContent)
            let queuedViewVariant
                let lastTrackedVariantId
                    let viewItemRetryCount = 0
                        const flushM7sViewItem = () => {
                              const suppressed = window.__varlaM7sViewItem?.suppressedGoogleViewItem
                                    if (!queuedViewVariant || !suppressed || typeof window.gtag !== 'function') {
                                            if (viewItemRetryCount < 40) {
                                                      viewItemRetryCount += 1
                                                                window.setTimeout(flushM7sViewItem, 50)
                                                                        }
                                                                                return
                                                                                      }
                                                                                            const variant = queuedViewVariant
                                                                                                  if (lastTrackedVariantId === String(variant.id)) return
                                                                                                        const itemId = 'shopify_ZZ_' + m7sProduct.id + '_' + variant.id
                                                                                                              const priceValue = Number(variant.price) / 100
                                                                                                                    const payload = {
                                                                                                                            ecomm_prodid: [itemId],
                                                                                                                                    ecomm_totalvalue: priceValue,
                                                                                                                                            ecomm_pagetype: 'product',
                                                                                                                                                    items: [{
                                                                                                                                                              id: itemId,
                                                                                                                                                                        name: m7sProduct.title,
                                                                                                                                                                                  brand: m7sProduct.vendor,
                                                                                                                                                                                            category: m7sProduct.type || '',
                                                                                                                                                                                                      price: priceValue,
                                                                                                                                                                                                                variant: variant.title || ''
                                                                                                                                                                                                                        }]
                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                    if (Array.isArray(suppressed.send_to)) payload.send_to = suppressed.send_to
                                                                                                                                                                                                                                          if (suppressed.developer_id) payload.developer_id = suppressed.developer_id
                                                                                                                                                                                                                                                window.gtag('event', 'view_item', payload)
                                                                                                                                                                                                                                                      lastTrackedVariantId = String(variant.id)
                                                                                                                                                                                                                                                          }
                                                                                                                                                                                                                                                              const scheduleM7sViewItem = variant => {
                                                                                                                                                                                                                                                                    queuedViewVariant = variant
                                                                                                                                                                                                                                                                          viewItemRetryCount = 0
                                                                                                                                                                                                                                                                                window.setTimeout(flushM7sViewItem, 0)
                                                                                                                                                                                                                                                                                    }
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100)
    const syncQuantity = () => {
      if (stickyQty && quantity) stickyQty.textContent = String(Math.max(1, Number(quantity.value || 1)))
    }
    const updateVariant = () => {
      const selected = []
      root.querySelectorAll('.m7s-option').forEach(group => {
        const checked = group.querySelector('input:checked')
        selected.push(checked ? checked.value : '')
        const label = group.querySelector('[data-selected-option]')
        if (label && checked) label.textContent = checked.value
      })
      const variant = variants.find(item => item.options.every((value, index) => value === selected[index]))
      if (!variant) return
      activeVariant = variant
      idInput.value = variant.id
      price.textContent = money(variant.price)
      if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''
      if (save) save.textContent = variant.compare_at_price > variant.price ? `Save ${money(variant.compare_at_price - variant.price)}` : ''
      add.disabled = !variant.available
      add.textContent = variant.available ? 'Add to cart' : 'Sold out'
      if (stickyPrice) stickyPrice.textContent = money(variant.price)
      if (stickyVariant) stickyVariant.textContent = variant.title
      if (stickyAdd) stickyAdd.disabled = !variant.available
      if (stickyBuyNow) stickyBuyNow.disabled = !variant.available
      const mainImage = root.querySelector('.m7s-main-image')
      if (mainImage && variant.featured_image?.src) {
        mainImage.removeAttribute('srcset')
        mainImage.removeAttribute('sizes')
        mainImage.src = variant.featured_image.src
        mainImage.alt = variant.featured_image.alt || `${variant.title} Varla M7S`
        if (stickyImage) {
          stickyImage.src = variant.featured_image.src
          stickyImage.alt = mainImage.alt
        }
      }
      const affirm = root.querySelector('.affirm-as-low-as')
      if (affirm) {
              affirm.dataset.amount = variant.price
                      if (window.affirm && window.affirm.ui) window.affirm.ui.refresh()
                            }
                                  scheduleM7sViewItem(variant)
                          }
    optionInputs.forEach(input => input.addEventListener('change', updateVariant))
    const black = optionInputs.find(input => input.value.toLowerCase() === 'black')
    if (black) black.checked = true
    updateVariant()
    root.querySelectorAll('[data-m7s-image]').forEach(button => button.addEventListener('click', () => {
      const main = root.querySelector('.m7s-main-image')
      if (main) {
        main.removeAttribute('srcset')
        main.removeAttribute('sizes')
        main.src = button.dataset.m7sImage
        if (button.dataset.m7sAlt) main.alt = button.dataset.m7sAlt
      }
      root.querySelectorAll('.m7s-thumb').forEach(item => item.classList.remove('is-active'))
      button.classList.add('is-active')
    }))
    optionInputs.forEach(input => input.addEventListener('change', () => {
      const color = input.value.toLowerCase()
      const matchingThumb = root.querySelector(`[data-m7s-color="${color}"]`)
      if (matchingThumb) matchingThumb.click()
    }))
    root.querySelector('[data-m7s-video-play]')?.addEventListener('click', () => {
      const video = root.querySelector('[data-m7s-video]')
      if (!video) return
      video.innerHTML = '<iframe src="https://www.youtube.com/embed/2qVDCRUAH1I?autoplay=1&rel=0" title="Official Varla M7S riding video" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
    })
    const creatorVideoDialog = root.querySelector('[data-m7s-creator-video-dialog]')
    const creatorVideoPlayer = root.querySelector('[data-m7s-creator-video-player]')
    const creatorVideoTitle = root.querySelector('[data-m7s-creator-video-title]')
    const closeCreatorVideo = () => {
      if (!creatorVideoDialog || !creatorVideoPlayer) return
      creatorVideoPlayer.pause()
      creatorVideoPlayer.removeAttribute('src')
      creatorVideoPlayer.load()
      if (creatorVideoDialog.open) creatorVideoDialog.close()
    }
    root.querySelectorAll('[data-m7s-creator-video]').forEach(button => button.addEventListener('click', () => {
      if (!creatorVideoDialog || !creatorVideoPlayer) return
      creatorVideoTitle.textContent = button.dataset.videoTitle || 'M7S video'
      creatorVideoPlayer.src = button.dataset.videoSrc
      creatorVideoDialog.showModal()
      creatorVideoPlayer.play().catch(() => {})
    }))
    root.querySelector('[data-m7s-creator-video-close]')?.addEventListener('click', closeCreatorVideo)
    creatorVideoDialog?.addEventListener('cancel', event => {
      event.preventDefault()
      closeCreatorVideo()
    })
    creatorVideoDialog?.addEventListener('click', event => {
      if (event.target === creatorVideoDialog) closeCreatorVideo()
    })
    root.querySelector('[data-qty-minus]')?.addEventListener('click', event => {
      const input = event.currentTarget.parentElement.querySelector('input')
      input.value = Math.max(1, Number(input.value || 1) - 1)
      input.dispatchEvent(new Event('change', {bubbles:true}))
    })
    root.querySelector('[data-qty-plus]')?.addEventListener('click', event => {
      const input = event.currentTarget.parentElement.querySelector('input')
      input.value = Number(input.value || 1) + 1
      input.dispatchEvent(new Event('change', {bubbles:true}))
    })
    quantity?.addEventListener('change', syncQuantity)
    quantity?.addEventListener('input', syncQuantity)
    syncQuantity()

    const reviewDialog = root.querySelector('[data-m7s-review-dialog]')
    const reviewList = root.querySelector('[data-m7s-review-list]')
    const reviewLoad = root.querySelector('[data-m7s-review-load]')
    const reviewEmpty = root.querySelector('[data-m7s-review-empty]')
    let reviewRows = []
    let reviewFilter = 'all'
    let reviewLimit = 12
    const escapeReview = value => String(value || '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]))
    const renderReviews = () => {
      if (!reviewList) return
      const ordered = [...reviewRows].sort((a, b) => reviewFilter === 'latest' ? String(b.date).localeCompare(String(a.date)) : 0)
      const filtered = ordered.filter(review => reviewFilter === 'all' || reviewFilter === 'latest' || (reviewFilter === 'media' ? Boolean(review.image) : review.model === reviewFilter))
      reviewList.innerHTML = filtered.slice(0, reviewLimit).map(review => {
        const image = review.image ? `<img src="${escapeReview(review.image)}" alt="Customer photo for ${escapeReview(review.title)}" width="900" height="675" loading="lazy">` : ''
        const status = review.verifiedPurchase ? 'Verified Purchase' : review.sourceType === 'official' ? 'Official-site review · Not marked verified' : 'Archive text · Not labeled verified'
        return `<article>${image}<span class="m7s-review-model">${escapeReview(review.model)}</span><span>${'★'.repeat(Number(review.rating) || 0)}${'☆'.repeat(5 - (Number(review.rating) || 0))}</span><h3>${escapeReview(review.title)}</h3><p>${escapeReview(review.body)}</p><b>${escapeReview(review.reviewer)}</b><small>${escapeReview(review.date)} · ${escapeReview(status)}</small></article>`
      }).join('')
      if (reviewLoad) {
        reviewLoad.hidden = filtered.length <= reviewLimit
        reviewLoad.textContent = `Load ${Math.min(12, Math.max(0, filtered.length - reviewLimit))} more`
      }
      if (reviewEmpty) reviewEmpty.hidden = filtered.length > 0
    }
    const loadReviewArchive = async () => {
      if (!reviewList || reviewRows.length) return
      reviewList.innerHTML = '<p>Loading review archive…</p>'
      try {
        const sources = [['M5S', reviewList.dataset.m5sSource], ['M7S', reviewList.dataset.m7sSource]]
        const [officialResponse, archives] = await Promise.all([
          fetch(reviewList.dataset.officialSource),
          Promise.all(sources.map(async ([model, source]) => {
          const response = await fetch(source, {credentials:'same-origin'})
          if (!response.ok) throw new Error(`${model} review archive ${response.status}`)
          return [model, await response.json()]
          }))
        ])
        if (!officialResponse.ok) throw new Error(`Official review source ${officialResponse.status}`)
        const officialArchive = await officialResponse.json()
        const officialRows = (Array.isArray(officialArchive.reviews) ? officialArchive.reviews : []).map(review => ({
          rating: review.rating,
          title: review.title,
          body: review.body,
          reviewer: review.reviewer_name,
          date: review.created_at,
          model: 'M5S',
          sourceType: 'official',
          verifiedPurchase: Boolean(review.verified_buyer),
          image: review.pictures_urls?.[0]?.original || review.pictures_urls?.[0]?.small || ''
        }))
        const archiveRows = archives.flatMap(([model, archive]) => (Array.isArray(archive.reviews) ? archive.reviews : []).map(review => ({...review, model, sourceType:'archive', verifiedPurchase:false, image:''})))
        reviewRows = [...officialRows, ...archiveRows]
        renderReviews()
      } catch (error) {
        reviewList.innerHTML = '<p>The review archive could not load. Please retry.</p>'
        console.error('[M7S review archive]', error)
      }
    }
    root.querySelector('[data-m7s-reviews-open]')?.addEventListener('click', () => {
      reviewDialog?.showModal()
      loadReviewArchive()
    })
    root.querySelector('[data-m7s-reviews-close]')?.addEventListener('click', () => reviewDialog?.close())
    root.querySelectorAll('[data-m7s-review-filter]').forEach(button => button.addEventListener('click', () => {
      reviewFilter = button.dataset.m7sReviewFilter
      reviewLimit = 12
      root.querySelectorAll('[data-m7s-review-filter]').forEach(item => item.classList.toggle('is-active', item === button))
      renderReviews()
    }))
    reviewLoad?.addEventListener('click', () => { reviewLimit += 12; renderReviews() })
    const mediaLightbox = root.querySelector('[data-m7s-media-lightbox]')
    root.querySelectorAll('[data-m7s-lightbox]').forEach(button => button.addEventListener('click', () => {
      const image = mediaLightbox?.querySelector('img')
      if (image) image.src = button.dataset.m7sLightbox
      mediaLightbox?.showModal()
    }))
    root.querySelector('[data-m7s-lightbox-close]')?.addEventListener('click', () => mediaLightbox?.close())

    root.querySelectorAll('[data-m7s-spec-tab]').forEach(button => button.addEventListener('click', () => {
      const target = button.dataset.m7sSpecTab
      root.querySelectorAll('[data-m7s-spec-tab]').forEach(tab => tab.setAttribute('aria-selected', String(tab === button)))
      root.querySelectorAll('[data-m7s-spec-panel]').forEach(panel => {
        panel.hidden = panel.dataset.m7sSpecPanel !== target
      })
    }))
    const trackingKeys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid']
    root.querySelectorAll('[data-model-link]').forEach(link => {
      const target = new URL(link.href, window.location.origin)
      const current = new URL(window.location.href)
      trackingKeys.forEach(key => {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key))
      })
      link.href = target.href
    })

    const countdown = root.querySelector('[data-m7s-countdown]')
    if (countdown) {
      const end = new Date(countdown.dataset.end).getTime()
      const fields = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      }
      const tick = () => {
        const remaining = Math.max(0, end - Date.now())
        const totalSeconds = Math.floor(remaining / 1000)
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60
        }
        Object.entries(values).forEach(([key, value]) => {
          if (fields[key]) fields[key].textContent = key === 'days' ? String(value) : String(value).padStart(2, '0')
        })
        if (remaining === 0) {
          const label = countdown.querySelector('[data-countdown-label]')
          if (label) label.textContent = 'Offer has ended'
          countdown.hidden = true
        }
      }
      tick()
      window.setInterval(tick, 1000)
    }

    const submitNativeForm = returnToCheckout => {
      if (!form || !activeVariant?.available) return
      let returnTo
      if (returnToCheckout) {
        returnTo = document.createElement('input')
        returnTo.type = 'hidden'
        returnTo.name = 'return_to'
        returnTo.value = '/checkout'
        form.appendChild(returnTo)
      }
      form.requestSubmit()
      if (returnTo) window.setTimeout(() => returnTo.remove(), 100)
    }
    stickyAdd?.addEventListener('click', () => submitNativeForm(false))
    stickyBuyNow?.addEventListener('click', () => submitNativeForm(true))
    if (sticky) {
      const cartRow = root.querySelector('.m7s-cart-row')
      const serviceStrip = root.querySelector('.m7s-service-strip')
      const allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      let stickyWasVisible = false
      let nudgeUsed = false
      let scheduled = false
      const updateSticky = () => {
        scheduled = false
        if (!cartRow) return
        const passedPurchase = cartRow.getBoundingClientRect().bottom < 0
        const reachedFooter = serviceStrip && serviceStrip.getBoundingClientRect().top < window.innerHeight
        const shouldShow = passedPurchase && !reachedFooter
        sticky.classList.toggle('is-visible', shouldShow)
        if (shouldShow && !stickyWasVisible && !nudgeUsed && stickyAdd && allowMotion) {
          nudgeUsed = true
          window.setTimeout(() => stickyAdd.classList.add('is-nudging'), 220)
        }
        stickyWasVisible = shouldShow
      }
      stickyAdd?.addEventListener('animationend', () => stickyAdd.classList.remove('is-nudging'))
      stickyAdd?.addEventListener('pointerdown', () => stickyAdd.classList.remove('is-nudging'), {passive:true})
      window.addEventListener('scroll', () => {
        if (scheduled) return
        scheduled = true
        window.requestAnimationFrame(updateSticky)
      }, {passive:true})
      window.addEventListener('resize', updateSticky)
      updateSticky()
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
